<template>
  <div class="PastRecommendations">
    <MobileNav :page_title="nav_title"></MobileNav>

    <div class="pastRecoContainer">
      <div class="desktopFilterSection">
        <!-- sent filter_list as props to desktop filter component to display filters by page type -->
        <FilterForDesktopView :filter_title="filter_title" :filter_list="filter_list"></FilterForDesktopView>
      </div>

      <div class="search-container">
        <div class="search-stock-section">
          <search-stock class="search-stock-component"></search-stock>
          <div class="export-section flex-center left-margin-5" v-if="(userProfile && userProfile.mark_as_verified_user) || publisherPlaData.plan == 'Publisher'">
            <div>
              <el-popover placement="bottom" title="Sort By Duration" width="225" trigger="click" content="Aggregated price estimates of users (only for short term)">
                <div class="top-margin-15">
                  <label class="input-label-gray" style="font-size: 11px">From</label>
                  <el-date-picker v-model="startDate" type="date" placeholder="Start Date" size="mini" format="dd-MM-yyyy" value-format="yyyy-MM-dd"></el-date-picker>
                </div>
                <div class="top-margin-15 bottom-margin-15">
                  <label class="input-label-gray" style="font-size: 11px">To</label>
                  <el-date-picker v-model="endDate" type="date" placeholder="End Date" size="mini" format="dd-MM-yyyy" value-format="yyyy-MM-dd"></el-date-picker>
                </div>
                <div slot="reference" class="filter-icon">
                  <img class="cursor-pointer" src="../assets/images/Filter Icon.svg" alt width="15px" />
                </div>
              </el-popover>
            </div>
            <el-button class="download-btn export-btn flex" style="" @click="getDataForDownloadExcel()" :disabled="startDate == null || endDate == null" :loading="isExcelDataLoading">
              <span style="position: relative; top: -2px">Export</span>
              <i class="el-icon-document" style="font-size: 20px; margin-left: 3px"></i>
            </el-button>
          </div>
        </div>
      </div>

      <div class="recoListSection">
        <div v-if="!is_list_loading && !past_reco_track_list.length">
          <NoDataFound></NoDataFound>
        </div>

        <div class="stock-data-section">
          <RecommendationDetailsCard :recommendationsList="past_reco_track_list" @getByStockName="getRecoByStockName" @openStockWidget="openStockWidget" @openUpdateRecoDialog="openUpdateRecoDialog" @openExitRecoDialog="openExitRecoDialog"></RecommendationDetailsCard>
        </div>

        <!-- btn to load more recos -->
        <div class="show-more-tab" v-if="this.number_of_pages > this.page_no && !is_list_loading" @click="loadMoreRecommendations()">Load more</div>

        <div :class="{ 'infinite-loader-top-position': page_no == 1 }" v-if="is_list_loading">
          <div class="text-center">
            <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px" />
            <p>Please wait, page is loading. . .</p>
          </div>
        </div>
      </div>
    </div>

    <!-- filters for mobile view -->
    <!-- isDesktop return true if window size is 1197px other wise false -->
    <StockFilter v-if="!isDesktop" :filter_title="filter_title" :filter_list="filter_list" class="nav-filter-icon"></StockFilter>

    <el-dialog custom-class="stock-widget-dialog" :visible.sync="stock_widget_visible" :before-close="handleClose">
      <div>
        <iframe :src="'https://stocks.tickertape.in/' + stock_code + '?broker=stockants'" width="100%" height="400px"></iframe>
      </div>
    </el-dialog>

    <el-dialog custom-class="reco-update-dialog" :visible.sync="update_recommendation_dialog_visible" title="Update Recommendation" :before-close="handleRecommendationDialog">
      <div>
        <el-card class="box-card update-reco-card relative" v-loading="reco_loading">
          <div style="display: flex; justify-content: space-between">
            <div class="flex">
              <div class="stock-title ellipsis" :title="selected_reco_to_update.name">
                {{ selected_reco_to_update.name }}
              </div>
              &nbsp;&nbsp;
              <span class="code-title" :title="selected_reco_to_update.name" v-if="selected_reco_to_update.symbol">({{ selected_reco_to_update.symbol }})</span>
            </div>
          </div>

          <div class="border-bottom-gray">
            <el-row class="top-margin-10 stock-details-section">
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <span class="current-price right-margin-10">₹ {{ selected_reco_to_update.current_price }}</span>
                <span class="right-margin-10 stock-section-inc" :style="[selected_reco_to_update.price_difference >= 0 ? { color: '#079e3e' } : { color: '#d60918' }]">
                  <span style="font-size: 18px" v-if="selected_reco_to_update.price_difference >= 0">&#9652;</span>
                  <span style="font-size: 18px" v-else>&#9662;</span>
                  {{ selected_reco_to_update.price_difference }} ({{ selected_reco_to_update.potential_difference }}%)
                </span>
              </el-col>

              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="sector-capitalized-section">
                <el-tag size="mini" class="right-margin-10 sector-tag" title="Market size" effect="plain" type="info" v-if="selected_reco_to_update.market_cap">
                  {{ selected_reco_to_update.market_cap }}
                </el-tag>

                <el-tag size="mini" class="right-margin-10 sector-tag" title="Market size" effect="plain" type="info" v-if="selected_reco_to_update.sector">
                  {{ selected_reco_to_update.sector }}
                </el-tag>
              </el-col>
            </el-row>

            <div class="input-label-gray" style="font-size: 10px" v-if="selected_reco_to_update.current_datetime">
              {{ selected_reco_to_update.current_datetime | stock_live_price_date_filter }}
            </div>
          </div>

          <div class="top-margin-10">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <div class="input-label-gray font-weight-500">
                  My Opinion
                  <el-popover placement="bottom" title="My Opinion" width="150" trigger="click" content="Select opinion">
                    <img class="info-Logo cursor-pointer" src="../assets/images/company/info-button.svg" slot="reference" />
                  </el-popover>
                </div>

                <div class="top-margin-5 margin-bottom-25">
                  <el-tag size="mini" class="selection-tag" value="Buy" :class="[selected_reco_to_update.reco == 'Buy' ? 'active-period-type' : 'inactive-period-type-tag']" style="cursor: not-allowed">BUY</el-tag>

                  <el-tag size="mini" class="selection-tag" value="Sell" :class="[selected_reco_to_update.reco == 'Sell' ? 'active-period-type' : 'inactive-period-type-tag']" style="cursor: not-allowed">SELL</el-tag>
                </div>
              </el-col>

              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-row :gutter="5">
                  <el-col :xs="24" :sm="12" :md="24" :lg="12" :xl="12" class="relative">
                    <div>
                      <div class="input-label-gray font-weight-500">
                        Reco Price
                        <el-popover placement="left" title="Reco Price" width="225" trigger="click" content="Price estimate (potential return in %)">
                          <img class="info-Logo cursor-pointer" src="../assets/images/company/info-button.svg" slot="reference" />
                        </el-popover>
                      </div>

                      <div class="top-margin-5" v-if="selected_reco_to_update.reco_price_type != 'MARKET'">
                        <div class="target-price-input-section width-100">
                          <div class="relative">
                            <span class="rupees-symbol">₹</span>

                            <span class="potential-return-value" v-if="selected_reco_to_update.reco_price_potential != ''">
                              {{ selected_reco_to_update.reco_price_potential }}
                              %
                            </span>
                            <span class="potential-return-value" v-else>0 %</span>

                            <el-input size="small" class="target-price-input" placeholder="Reco price" type="number" v-model="selected_reco_to_update.reco_price" @input.native="validateRecoPrice(selected_reco_to_update.reco_price, selected_reco_to_update.target_price, 'input', selected_reco_to_update.reco)" :disabled="selected_reco_to_update.reco_status == 'LIVE' || selected_reco_to_update.reco_status == 'UPDATED'" @change="selected_reco_to_update.added_first == 'target price' ? calculateStopLoss(selected_reco_to_update.reco_price, selected_reco_to_update.target_price) : selected_reco_to_update.added_first == 'stop loss' ? calculateTargetPrice(selected_reco_to_update.reco_price, selected_reco_to_update.stop_loss) : ''"></el-input>
                          </div>
                        </div>
                      </div>

                      <div class="top-margin-5">
                        <el-popover class="error-pop" placement="top" width="280" trigger="click" v-model="selected_reco_to_update.validate_reco_price" :content="selected_reco_to_update.reco_price_error_text"></el-popover>
                      </div>
                    </div>
                    <div v-if="selected_reco_to_update.reco_price_type == 'MARKET'">
                      <el-input size="small" class="target-price-input" placeholder="LTP" v-model="reco_price_market" :disabled="selected_reco_to_update.reco_price_type == 'MARKET'"></el-input>
                    </div>
                  </el-col>

                  <el-col :xs="24" :sm="12" :md="24" :lg="12" :xl="12" class="relative" v-if="selected_reco_to_update.reco_status == 'YET TO LIVE'">
                    <div class="top-margin-25 left-margin-10">
                      <el-radio :disabled="isMarketClose" v-model="selected_reco_to_update.reco_price_type" label="MARKET">Market</el-radio>
                      <el-radio v-model="selected_reco_to_update.reco_price_type" label="LIMIT">Limit</el-radio>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

            <el-row :gutter="10" class="top-margin-10">
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <div>
                  <div class="input-label-gray font-weight-500 top-margin-5">Target Period</div>
                  <el-select v-model="selected_reco_to_update.duration" placeholder="Duration" size="small" class="quarter-tag top-margin-5" :disabled="selected_reco_to_update.short_term_duration || selected_reco_to_update.reco_status == 'LIVE' || selected_reco_to_update.reco_status == 'UPDATED' ? true : false" filterable style="border-radius: 15px; width: 100%" @change="changeTargetPeriod()">
                    <el-option v-for="selected_reco_to_update in filteredTargetPeriods" :key="selected_reco_to_update.title" :label="selected_reco_to_update.title" :value="selected_reco_to_update.value"></el-option>
                  </el-select>

                  <div class="input-label-gray font-weight-500 top-margin-15">
                    Duration
                    <el-popover placement="left" title="Target Period" width="150" trigger="click" content="Select target period">
                      <img class="info-Logo cursor-pointer" src="../assets/images/company/info-button.svg" slot="reference" />
                    </el-popover>
                  </div>

                  <div class="top-margin-5">
                    <!-- {{ selected_reco_to_update.selected_target_period_list }}1234 -->
                    <el-select v-model="selected_reco_to_update.selected_duration" placeholder="Short term" size="small" class="quarter-tag" :disabled="selected_reco_to_update.long_term_duration || selected_reco_to_update.reco_status == 'LIVE' || selected_reco_to_update.reco_status == 'UPDATED' ? true : false" filterable style="border-radius: 15px; width: 100%">
                      <el-option v-for="selected_reco_to_update in selected_reco_to_update.selected_duration_list" :key="selected_reco_to_update.label" :label="`${selected_reco_to_update.result_date_title} (${selected_reco_to_update.label})`" :value="selected_reco_to_update.result_date"></el-option>
                    </el-select>
                  </div>
                </div>
                <!-- <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <div>
                    <div class="input-label-gray font-weight-500 top-margin-15">
                      Risk Tags
                      <el-popover placement="left" title="Risk Tags" trigger="click" content="Select risk level"></el-popover>
                    </div>

                    <div class="top-margin-5">
                      <el-select v-model="selected_reco_to_update.risk_tag" placeholder="Select Risk Level" size="small" class="risk-tag" :disabled="selected_reco_to_update.reco_status == 'LIVE' || selected_reco_to_update.reco_status == 'UPDATED' ? true : false" clearable filterable style="border-radius: 15px; width: 100%">
                        <el-option v-for="option in risk_tags_options" :key="option.value" :label="option.label" :value="option.value"></el-option>
                      </el-select>
                    </div>
                  </div>
                </el-col> -->
              </el-col>

              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="relative">
                <el-row>
                  <el-col :xs="24" :sm="12" :md="24" :lg="12" :xl="12" class="relative">
                    <div class="input-label-gray font-weight-500 top-margin-5">
                      Target Price
                      <el-popover placement="left" title="Target Price" width="225" trigger="click" content="Price estimate (potential return in %)">
                        <img class="info-Logo cursor-pointer" src="../assets/images/company/info-button.svg" slot="reference" />
                      </el-popover>
                    </div>

                    <div class="top-margin-5">
                      <div class="target-price-input-section width-100">
                        <div class="relative">
                          <span class="rupees-symbol">₹</span>

                          <span class="potential-return-value" v-if="selected_reco_to_update.target_price_potential != ''">
                            {{ selected_reco_to_update.target_price_potential }}
                            %
                          </span>
                          <span class="potential-return-value" v-else>0 %</span>

                          <span v-if="selected_reco_to_update.reco == 'Buy'">
                            <el-input size="small" class="target-price-input" placeholder="Target price" v-model="selected_reco_to_update.target_price" @input.native="validateTargetPrice(selected_reco_to_update.target_price, selected_reco_to_update.current_price, selected_reco_to_update.reco)" @change="calculateStopLoss(selected_reco_to_update.reco_price, selected_reco_to_update.target_price)" :min="selected_reco_to_update.target_price_limit" type="number"></el-input>
                          </span>
                          <span v-else-if="selected_reco_to_update.reco == 'Sell'">
                            <el-input size="small" class="target-price-input" placeholder="Target price" v-model="selected_reco_to_update.target_price" @input.native="validateTargetPrice(selected_reco_to_update.target_price, selected_reco_to_update.current_price, selected_reco_to_update.reco)" @change="calculateStopLoss(selected_reco_to_update.reco_price, selected_reco_to_update.target_price)" min="0" type="number" :max="selected_reco_to_update.target_price_limit"></el-input>

                            {{ selected_reco_to_update.target_price_limit }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="top-margin-5">
                      <el-popover class="error-pop" placement="top" width="280" trigger="click" v-model="selected_reco_to_update.validate_target_price" :content="selected_reco_to_update.target_price_error_text"></el-popover>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="24" :lg="12" :xl="12" class="relative">
                    <div class="input-label-gray font-weight-500 top-margin-5">
                      Stop Loss
                      <span v-if="selected_reco_to_update.short_term_duration" style="color: red; font-size: 17px">*</span>
                      <el-popover placement="left" title="Stop Loss" width="225" trigger="click" content="Price estimate (potential return in %)">
                        <img class="info-Logo cursor-pointer" src="../assets/images/company/info-button.svg" slot="reference" />
                      </el-popover>
                    </div>

                    <div class="top-margin-5">
                      <div class="target-price-input-section width-100">
                        <div class="relative">
                          <span class="rupees-symbol">₹</span>

                          <span class="potential-return-value" v-if="selected_reco_to_update.stop_loss_potential != ''">{{ selected_reco_to_update.stop_loss_potential }} %</span>
                          <span class="potential-return-value" v-else>0 %</span>

                          <span v-if="selected_reco_to_update.reco == 'Buy'">
                            <el-input size="small" class="target-price-input" placeholder="Stop loss" v-model="selected_reco_to_update.stop_loss" @input.native="validateStopLoss(selected_reco_to_update.stop_loss, selected_reco_to_update.current_price, selected_reco_to_update.reco)" :min="selected_reco_to_update.stop_loss_limit" :max="selected_reco_to_update.reco_price - 2" type="number" />
                          </span>
                          <span v-else-if="selected_reco_to_update.reco == 'Sell'">
                            <el-input size="small" class="target-price-input" placeholder="Stop loss" v-model="selected_reco_to_update.stop_loss" @input.native="validateStopLoss(selected_reco_to_update.stop_loss, selected_reco_to_update.current_price, selected_reco_to_update.reco)" :max="selected_reco_to_update.stop_loss_limit" :min="selected_reco_to_update.reco_price - 2" type="number" />
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="top-margin-5">
                      <el-popover class="error-pop" placement="bottom" width="280" trigger="click" v-model="selected_reco_to_update.validate_stop_loss" :content="selected_reco_to_update.stop_loss_error_text" />
                    </div>
                  </el-col>
                </el-row>
              </el-col>

              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="relative">
                <div class="top-margin-10">
                  <div class="input-label-gray font-weight-500 top-margin-5">
                    Logic Tags
                    <span class="required-field">*</span>
                    <span style="font-size: 9px">(Min 3)</span>
                  </div>
                  <div class="top-margin-5">
                    <el-select v-model="selected_reco_to_update.selected_logic_list" placeholder="Logic Tags" size="small" class="logic-tags" multiple :disabled="selected_reco_to_update.reco_status == 'LIVE' || selected_reco_to_update.reco_status == 'UPDATED' ? true : false" clearable filterable collapse-tags style="border-radius: 15px; width: 100%">
                      <el-option v-for="option in filtered_logic_list" :key="option.value" :label="option" :value="option"></el-option>
                    </el-select>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="relative">
                <div class="top-margin-15 stamp-dropdown">
                  <div class="input-label-gray font-weight-500 top-margin-5">
                    Stamps
                    <span class="required-field">*</span>
                  </div>
                  <div class="top-margin-5">
                    <el-select v-model="selected_reco_to_update.stamps_list" placeholder="Category Stamps" size="small" style="width: 100%" multiple class="bottom-margin-10">
                      <el-option v-for="(option, index) in stamp_list" :key="index" :label="option" :value="option"></el-option>
                    </el-select>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="top-margin-5">
                  <div class="input-label-gray font-weight-500">Edit Description <span class="required-field">*</span></div>
                  <el-input class="top-margin-5" type="textarea" :rows="4" resize="none" placeholder="Write a brief description..." v-model="selected_reco_to_update.edit_description"></el-input>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="10" class="top-margin-10">
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                
              </el-col>
            </el-row>
          </div>

          <!-- recommend btn -->
          <div class="recommendation-section top-margin-10" style="display: flex; justify-content: flex-end">
            <div class="top-margin-5">
              <el-button class="btn-theme-borderd" size="small" round plain v-if="!selected_reco_to_update.is_recommended" :loading="selected_reco_to_update.is_btn_loading" v-on:click="updateReco(selected_reco_to_update)" style="width: 100%; padding: 5px 70px 5px 70px">UPDATE</el-button>

              <el-button class="btn-theme-filled" size="small" round icon="el-icon-check" plain v-if="selected_reco_to_update.is_recommended" :loading="selected_reco_to_update.is_btn_loading" style="cursor: not-allowed; width: 100%">UPDATED</el-button>
            </div>
          </div>
        </el-card>
      </div>
    </el-dialog>

    <el-dialog custom-class="reco-update-dialog" :visible.sync="exit_reco_popup_visible" title="Exit Recommendation" :before-close="handleRecommendationDialog">
      <div>
        <el-card class="box-card update-reco-card relative" v-loading="reco_loading">
          <div style="display: flex; justify-content: space-between">
            <div class="flex">
              <div class="stock-title ellipsis" :title="selected_reco_to_update.name">
                {{ selected_reco_to_update.name }}
              </div>
              &nbsp;&nbsp;
              <span class="code-title" :title="selected_reco_to_update.name" v-if="selected_reco_to_update.symbol">({{ selected_reco_to_update.symbol }})</span>
            </div>
          </div>

          <div class="border-bottom-gray">
            <el-row class="top-margin-10 stock-details-section">
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <span class="current-price right-margin-10">₹ {{ selected_reco_to_update.current_price }}</span>
                <span class="right-margin-10 stock-section-inc" :style="[selected_reco_to_update.price_difference >= 0 ? { color: '#079e3e' } : { color: '#d60918' }]">
                  <span style="font-size: 18px" v-if="selected_reco_to_update.price_difference >= 0">&#9652;</span>
                  <span style="font-size: 18px" v-else>&#9662;</span>
                  {{ selected_reco_to_update.price_difference }} ({{ selected_reco_to_update.potential_difference }}%)
                </span>
              </el-col>

              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="sector-capitalized-section">
                <el-tag size="mini" class="right-margin-10 sector-tag" title="Market size" effect="plain" type="info" v-if="selected_reco_to_update.market_cap">
                  {{ selected_reco_to_update.market_cap }}
                </el-tag>

                <el-tag size="mini" class="right-margin-10 sector-tag" title="Market size" effect="plain" type="info" v-if="selected_reco_to_update.sector">
                  {{ selected_reco_to_update.sector }}
                </el-tag>
              </el-col>
            </el-row>

            <div class="input-label-gray" style="font-size: 10px" v-if="selected_reco_to_update.current_datetime">
              {{ selected_reco_to_update.current_datetime | stock_live_price_date_filter }}
            </div>
          </div>

          <div class="top-margin-20">
            <div class="input-label-gray font-weight-500 bottom-margin-10">Exit Description <span class="required-field">*</span></div>
            <el-input type="textarea" :rows="4" resize="none" placeholder="Write a brief description..." v-model="selected_reco_to_update.exit_description"></el-input>
          </div>

          <!-- recommend btn -->
          <div class="recommendation-section top-margin-10" style="display: flex; justify-content: flex-end">
            <div class="top-margin-5">
              <el-button class="btn-theme-borderd" size="small" round plain :loading="selected_reco_to_update.is_btn_loading" v-on:click="exitReco(selected_reco_to_update)" style="width: 100%; padding: 5px 70px 5px 70px">EXIT</el-button>
            </div>
          </div>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { serverAddr } from '../networkConfig';
import MobileNav from '@/components/MobileNav.vue';
import SearchStock from '@/components/SearchStock.vue';
import RecoActionButtons from '@/components/RecoActionButtons.vue';
import MobileFilterDialog from '@/components/MobileFilterDialog.vue';
import FilterForDesktopView from '@/components/FilterForDesktopView.vue';
import NoDataFound from '@/components/NoDataFound.vue';
import { screenSize } from '../mixins/ScreenSize.js';
import { filterCallBack } from '../mixins/filter';
import { EventBus } from '../eventBus';
import RecommendationDetailsCard from '@/components/RecommendationDetailsCard.vue';
import { HelperNetworkCallBack } from '../mixins/Helper';
import CripNotice from 'crip-vue-notice';
import moment from 'moment';
import ExcelJS from 'exceljs';

export default {
  name: 'PastRecommendations',

  mixins: [HelperNetworkCallBack, filterCallBack, screenSize],

  components: {
    MobileNav,
    'search-stock': SearchStock,
    NoDataFound,
    RecoActionButtons,
    FilterForDesktopView,
    RecommendationDetailsCard,
    StockFilter: MobileFilterDialog,
  },

  data() {
    return {
      nav_title: 'Past Recommendations',
      filter_title: 'Past recommendations',
      is_list_loading: false,
      past_reco_track_list: [],
      stock_list: '',
      filter_list: [
        {
          title: 'Recommendation type',
          filter: ['Buy', 'Sell'],
        },
        {
          title: 'Market cap',
          filter: ['Large Cap', 'Mid Cap', 'Small Cap'],
        },
        {
          title: 'Sectors',
        },
        {
          title: 'Recommendation status',
          filter: [
            'Live',
            'Updated',
            // "Closed",
            'Yet to live',
            'Target achieved',
            'Target not achieved',
            'Stop loss triggered',
            'Exit',
          ],
        },
        {
          title: 'Target period',
        },
      ],
      target_period_type_list: [
        {
          label: 'Intraday',
          value: 'Intra',
        },
        {
          label: 'Short Term',
          value: 'Short-Term',
        },
        {
          label: 'Mid Term',
          value: 'Mid-Term',
        },
        {
          label: 'Long Term',
          value: 'Long-Term',
        },
      ],
      filter_obj: {
        sector: '',
        target_period: {},
        filters: [],
      },
      is_scroll_disabled: true,
      page_no: 1,
      number_of_pages: null,
      stock_code: '',
      stock_widget_visible: false,
      kite: '',
      update_recommendation_dialog_visible: false,

      selected_reco_to_update: {},
      selected_reco_index: '',
      short_term_target_period_list: [],
      long_term_target_period_list: [],
      reco_loading: false,
      reco_price_market: '',
      risk_tags_options: [
        {
          label: 'Low Risk',
          value: 'low_risk',
        },
        {
          label: 'Moderate Risk',
          value: 'moderate_risk',
        },
        {
          label: 'High Risk',
          value: 'high_risk',
        },
      ],

      tags_data: {
        intraday: {
          buy: ['Scalping', 'Range Trading', 'News Based', 'Technical Based', 'Bullish Chart Pattern', 'Arbitrage', 'High Profit Probability', 'Short-term Profit', 'Event Based', 'Bullish Reversal', 'Volatility', 'Uptrend', 'Breakout', 'Support Zone', 'Trade Volume Based'],
          sell: ['Scalping', 'Range Trading', 'News Based', 'Technical Based', 'Bearish Chart Pattern', 'Arbitrage', 'High Profit Probability', 'Short-term Profit', 'Event Based', 'Bearish Reversal', 'Volatility', 'Downtrend', 'Breakout', 'Resistance Zone', 'Trade Volume Based'],
        },

        short_term: {
          buy: ['BTST Trade', 'Swing Trade', 'News Based', 'Technical Based', 'Bullish Chart pattern', 'High Profit Probability', 'Short-term Profit', 'Event Based', 'Bullish Reversal', 'Volatility', 'Postional Trading', 'Momentum Trading', 'Support Zone', 'Uptrend'],
          sell: ['BTST Trade', 'Swing Trade', 'News Based', 'Technical Based', 'Bearish Chart pattern', 'High Profit Probability', 'Short-term Profit', 'Event Based', 'Bearish Reversal', 'Volatility', 'Positional Trading', 'Momentum Trading', 'Resistance Zone', 'Downtrend'],
        },

        long_term: {
          buy: ['Lower Charges/Commissions', 'Fundamental Based', 'High Profit Probability', 'Better Long-term Returns', 'Dividends', 'Compounding', 'Uptrend', 'LowerTax Rates'],
          sell: ['Lower Charges/Commissions', 'Fundamental Based', 'High Profit Probability', 'Better Long-term Returns', 'Dividends', 'Compounding', 'Downtrend', 'LowerTax Rates'],
        },
      },
      filtered_logic_list: [],
      isMarketClose: false,
      isExcelDataLoading: false,
      exportRecoList: [],
      startDate: null,
      endDate: null,
      publisherPlaData: {},
      // selected_stamps_list: [],
      stamp_list: ['SIP', 'Momentum Picks', 'FII/DII Activity', 'News based', 'Undiscovered gems', 'Multibagger'],
      exit_reco_popup_visible: false,
    };
  },

  // props: ['stock_id'],

  //when route is revisited then this life cycle is called
  beforeRouteUpdate(to, from, next) {
    this.stock_list = ''; //cleared selected stock
    this.page_no = 1;
    this.past_reco_track_list = []; //cleared reco list
    this.filter_obj = {
      sector: '',
      target_period: {},
      filters: [],
    };

    this.getAllPastRecoList({}); //api called on page load to get users reco list
    next();
  },

  mounted() {
    this.checkMarketStatus();

    //if query params in route then assigned stock name in stock_list if sector then sector
    if (this.$route.query.stock_id) {
      this.stock_list = this.$route.query.stock_id;

      //get all short term reco data track
      this.getAllPastRecoList(this.filter_obj);
    } else if (this.$route.query.sector) {
      this.filter_obj.sector = this.$route.query.sector;

      //get all short term reco data track
      this.getAllPastRecoList(this.filter_obj);
    } else if (this.$route.query.reco_id) {
      this.getRecommendationByRecoId(this.$route.query.reco_id);
    } else {
      //get all short term reco data track
      this.getAllPastRecoList(this.filter_obj);
    }

    if (localStorage.getItem('publisher_plan_details')) {
      this.publisherPlaData = JSON.parse(localStorage.getItem('publisher_plan_details'));
    }

    //event emmited when stock is removed
    EventBus.$on('clearedSearchedStock', () => {
      this.page_no = 1;
      this.stock_list = '';
      this.other_expert_past_reco_list = [];

      this.scrollToTop(); //scroll to top of list
      this.getAllPastRecoList(this.filter_obj);
    });

    EventBus.$on('clearedSelectedFilter', (filter_obj) => {
      this.stock_list = '';
      this.page_no = 1;
      this.past_reco_track_list = [];
      this.scrollToTop();
      this.filter_obj = filter_obj;
      this.getAllPastRecoList(this.filter_obj);
    });

    EventBus.$on('emitSelectedFilters', (filter_obj) => {
      this.page_no = 1;
      this.past_reco_track_list = [];
      this.scrollToTop();
      this.filter_obj = filter_obj;
      this.getAllPastRecoList(this.filter_obj);
    });

    //event emmited when stock is selected
    EventBus.$on('selectedStock', (stock) => {
      this.stock_list = '';
      this.page_no = 1;
      this.past_reco_track_list = [];
      this.stock_list = stock.id;
      this.scrollToTop(); //scroll to top of list
      if (this.stock_list) {
        this.getAllPastRecoList(this.filter_obj);
      }
    });
  },

  computed: {
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },

    filteredTargetPeriods() {
      if (this.selected_reco_to_update.reco === 'Sell') {
        // If recommendation type is 'Sell', show only 'Intraday'
        return this.target_period_type_list.filter((option) => option.value === 'Intra');
      } else {
        // Otherwise, show all target period options
        return this.target_period_type_list;
      }
    },
  },
  methods: {
    removeAttachment(index) {
    },
    // get attached logic references
    getDataForDownloadExcel() {
      this.isExcelDataLoading = true;

      serverAddr
        .get(`/recommendation/v1/my_view_expert_equity?from=${this.startDate}&to=${this.endDate}`)
        .then((response) => {
          if (response.data.status) {
            this.exportRecoList = response.data.data;
            this.downloadExcel();
          } else {
          }
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },
    async downloadExcel() {
      try {
        const outputArray = [];
        this.exportRecoList.forEach((item) => {
          outputArray.push({
            'Reco Time stamp': moment(item.created_at).format('MMM DD YYYY, hh:mm A'),
            'Stock Name': item.stock.name,
            'Reco Type': item.reco,
            'Target Period': item.target_period,
            'Reco Price': item.reco_price,
            'Target Price': item.target_price,
            Stoploss: item.stop_loss,
            'Reco Status': item.reco_status,
            'Reco Status Time Stamp': item.reco_status == 'CLOSED' ? moment(item.closed_date_time).format('MMM DD YYYY, hh:mm A') : item.reco_status == 'TARGET ACHIEVED' ? moment(item.target_achieved_date_time).format('MMM DD YYYY, hh:mm A') : item.reco_status == 'TARGET NOT ACHIEVED' ? moment(item.target_not_achieved_date_time).format('MMM DD YYYY, hh:mm A') : item.reco_status == 'STOP LOSS TRIGGERED' ? moment(item.stop_loss_triggered_date_time).format('MMM DD YYYY, hh:mm A') : item.reco_status == 'LIVE' || item.reco_status == 'YET TO LIVE' || item.reco_status == 'UPDATED' ? moment(item.stock.today).format('MMM DD YYYY, hh:mm A') : item.stock.today,
            'Reco Status current price': item.reco_status == 'CLOSED' ? item.closed_price : item.reco_status == 'TARGET ACHIEVED' ? item.target_achieved_price : item.reco_status == 'TARGET NOT ACHIEVED' ? item.target_not_achieved_price : item.reco_status == 'STOP LOSS TRIGGERED' ? item.stop_loss_triggered_price : item.reco_status == 'LIVE' || item.reco_status == 'YET TO LIVE' || item.reco_status == 'UPDATED' ? item.stock.current_price : item.stock.current_price,
            'Target potential %': item.max_profit_in_percentage,
            Performance: item.performance,
            'Remaining potential as of current date': item.potential_as_of_current_date,
            'Max downside': item.max_loss,
            'Max downside %': item.max_loss_in_percentage,
            'Max upside': item.max_profit,
            'Max upside %': item.max_profit_in_percentage,
            'Risk Tag': item.risk_tag,
            'Logic Tag': item.logic_tags,
          });
        });

        // Define headers and their desired order
        const headers = ['Reco Time stamp', 'Stock Name', 'Reco Type', 'Target Period', 'Reco Price', 'Target Price', 'Stoploss', 'Reco Status', 'Reco Status Time Stamp', 'Reco Status current price', 'Target potential %', 'Performance', 'Remaining potential as of current date', 'Max downside', 'Max downside %', 'Max upside', 'Max upside %', 'Risk Tag', 'Logic Tag'];

        // Create a new workbook
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // Add headers
        worksheet.addRow(headers);

        // Add data to worksheet
        outputArray.forEach((item) => {
          const row = headers.map((header) => (item[header] !== undefined ? item[header] : null));
          worksheet.addRow(row);
        });

        // Set column widths
        const columnWidths = {
          A: 30,
          B: 20,
          C: 10,
          D: 20,
          E: 15,
          F: 15,
          G: 15,
          H: 30,
          I: 30,
          J: 30,
          K: 20,
          L: 15,
          M: 40,
          N: 15,
          O: 15,
          P: 15,
          Q: 15,
          R: 20,
          S: 80,
        };

        Object.keys(columnWidths).forEach((column, index) => {
          worksheet.getColumn(index + 1).width = columnWidths[column];
        });

        // Center-align all columns
        worksheet.eachRow((row, rowNumber) => {
          row.eachCell((cell, colNumber) => {
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
          });
        });

        // Generate Excel file
        const buffer = await workbook.xlsx.writeBuffer();

        // Create Blob
        const blob = new Blob([buffer], { type: 'application/octet-stream' });

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Recommendation List.xlsx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        setTimeout(() => {
          this.isExcelDataLoading = false;
        }, 1000);
      } catch (error) {
        setTimeout(() => {
          this.isExcelDataLoading = false;
        }, 1000);
        console.error('Error exporting to Excel:', error);
      }
    },
    checkMarketStatus() {
      var format = 'hh:mm:ss';

      // real time
      var time = moment();
      var todayDate = moment().format('YYYY-MM-DD');

      var beforeTime = moment('09:15:00', format);
      var afterTime = moment('15:30:00', format);

      if (time.isBetween(beforeTime, afterTime)) {
        serverAddr
          .get('/base/v1/holiday')
          .then((response) => {
            // check for market holiday
            this.isMarketClose = response.data.data.includes(todayDate) == true ? true : false;
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        this.isMarketClose = true;
      }
    },

    changeTargetPeriod() {
      this.selected_reco_to_update.selected_duration = '';

      this.selected_reco_to_update.selected_duration_list = this.selected_reco_to_update.duration == 'Intra' ? this.intra_target_period_list : this.selected_reco_to_update.duration == 'Short-Term' ? this.short_term_target_period_list : this.selected_reco_to_update.duration == 'Mid-Term' ? this.mid_term_target_period_list : this.long_term_target_period_list;

      // reset logic tags on update target period
      this.filtered_logic_list = [];
      this.selected_reco_to_update.selected_logic_list = [];

      this.getTagsDataList();
    },
    exitReco() {
  // Validate exit description
  if (!this.selected_reco_to_update.exit_description || !this.selected_reco_to_update.exit_description.trim()) {
    new CripNotice({
      title: 'Error',
      description: 'Exit description is required.',
      type: 'error',
      duration: 3,
    });
    return;
  }

  this.selected_reco_to_update.is_btn_loading = true;

  serverAddr
    .patch(`/recommendation/v1/edit/${this.selected_reco_to_update.reco_id}`, {
      reco_status: '7',
      reco_update_type: 'EXIT',
      exit_description: this.selected_reco_to_update.exit_description,
    })
    .then((response) => {
      if (response.data.status) {
        new CripNotice({
          title: 'Success',
          description: 'Recommendation exited successfully.',
          type: 'success',
          duration: 3,
        });

        // update local list with fresh data
        let updated_reco = response.data.data;

        this.$set(updated_reco, 'toggle_more_info', false);
        this.$set(updated_reco, 'expert_list', []);
        this.$set(updated_reco, 'closed_reco_list', []);
        this.$set(updated_reco, 'closed_reco_list_loading', false);
        this.$set(updated_reco, 'is_loading', false);
        this.$set(updated_reco, 'compared_experts_list', []);

        if (updated_reco.created_at && updated_reco.stock && updated_reco.stock.today) {
          let end_date = updated_reco.reco_status === 'TARGET ACHIEVED'
            ? updated_reco.target_achieved_date_time
            : updated_reco.reco_status === 'TARGET NOT ACHIEVED'
              ? updated_reco.target_not_achieved_date_time
              : updated_reco.reco_status === 'STOP LOSS TRIGGERED'
                ? updated_reco.stop_loss_triggered_date_time
                : updated_reco.stock.today;

          updated_reco.difference_in_days = this.getDifferenceBetweenTwoDays(updated_reco.created_at, end_date);
        } else {
          updated_reco.difference_in_days = 0;
        }

        // replace updated reco in list
        this.past_reco_track_list.splice(this.selected_reco_index, 1, updated_reco);

        this.exit_reco_popup_visible = false;
      }

      this.selected_reco_to_update.is_btn_loading = false;
    })
    .catch((error) => {
      console.log(error);
      this.selected_reco_to_update.is_btn_loading = false;
    });
},

    openExitRecoDialog(reco_details) {
      this.exit_reco_popup_visible = true;

      this.setUpdateRecoData(reco_details);
    },

    openUpdateRecoDialog(reco_details) {
      this.update_recommendation_dialog_visible = true;
      this.setUpdateRecoData(reco_details);

      this.getTagsDataList();
    },

    async setUpdateRecoData(reco_details) {

      console.log(reco_details, 'SASreco details###############');
      
      this.reco_loading = true; //displayed loader

      if (!this.short_term_target_period_list.length && !this.long_term_target_period_list.length) {
        let target_period_res = await this.getTargetPeriod();

        if (target_period_res.data.status && target_period_res.data.data.length) {
          if (target_period_res.data.status && target_period_res.data.data.length) {
            this.intra_target_period_list = target_period_res.data.data.filter((e) => {
              return e.period == 'Intra';
            });
            this.short_term_target_period_list = target_period_res.data.data.filter((e) => {
              return e.period == 'Short-Term';
            });
            this.mid_term_target_period_list = target_period_res.data.data.filter((e) => {
              return e.period == 'Mid-Term';
            });

            this.long_term_target_period_list = target_period_res.data.data.filter((e) => {
              return e.period == 'Long-Term';
            });
          }
        }
      }

      let reco = reco_details.reco_data;

      this.selected_reco_index = reco_details.index; //selected reco index

      // //calculated potential return initially when target price is initiallised
      let reco_price_potential = this.getPotentailReturn(reco.reco_price, reco.stock.current_price, reco.reco);

      this.selected_reco_to_update = {
        name: reco.stock.name,
        symbol: reco.stock.symbol,
        sector: reco.stock.sector,
        market_cap: reco.stock.market_cap,
        current_datetime: reco.stock.current_datetime,
        current_price: reco.stock.current_price,
        potential_difference: reco.stock.potential_difference,
        price_difference: reco.stock.price_difference,
        duration: '',
        // logic_tags: reco.selectedLogicTags,
        selected_duration_list: reco.duration == 'IntraDay' ? this.intra_target_period_list : reco.duration == 'Week' || reco.duration == 'Month' ? this.short_term_target_period_list : (reco.duration == reco.duration) == 'Quarter' ? this.mid_term_target_period_list : this.long_term_target_period_list,
        selected_duration: reco.target_period,
        is_unlocked: reco.antestimate_number ? true : false,
        antestimate_number: reco.antestimate_number ? reco.antestimate_number : '',
        is_recommended: false,
        is_btn_loading: false,
        reco_id: reco.id,
        reco_price: Number(reco.reco_open_price),
        target_price: reco.target_price,
        stop_loss: reco.stop_loss,
        reco: reco.reco,
        reco_status: reco.reco_status,
        validate_stop_loss: false,
        validate_target_price: false,
        validate_reco_price: false,
        target_price_error_text: '',
        target_price_potential: reco.target_potential,
        reco_price_potential: reco_price_potential,
        stop_loss_potential: reco.stop_loss_potential && reco.stop_loss_potential != 'NA' ? reco.stop_loss_potential : 0,

        reco_price_type: reco.reco_status == 'YET TO LIVE' && !this.isMarketClose ? 'MARKET' : 'LIMIT',
        selected_logic_list: reco.logic_tags,
        added_first: '',
        duration: reco.duration == 'IntraDay' ? 'Intra' : reco.duration == 'Week' || reco.duration == 'Month' ? 'Short-Term' : reco.duration == 'Quarter' ? 'Mid-Term' : 'Long-Term',
        risk_tag: reco.risk_tag,
        stamps_list: reco.category_stamp,
        exit_description: '',
        edit_description: '',
      };
      this.reco_loading = false; //hide loader
    },

    getTagsDataList() {
      if (this.selected_reco_to_update.reco && this.selected_reco_to_update.duration) {
        var periodMapping = {
          Intra: 'intraday',
          'Short-Term': 'short_term',
          'Mid-Term': 'short_term',
          'Long-Term': 'long_term',
        };

        var periodKey = periodMapping[this.selected_reco_to_update.duration];

        this.filtered_logic_list = this.tags_data && this.tags_data[periodKey] ? this.tags_data[periodKey][this.selected_reco_to_update.reco.toLowerCase()] : [];
      }
    },

    openStockWidget(stock_code) {
      this.stock_code = stock_code;
      this.stock_widget_visible = true;
    },

    openTradeWidget(stock_code, reco_id) {
      if (KiteConnect) {
        KiteConnect.ready(async function () {
          // Initialize a new Kite instance.
          // You can initialize multiple instances if you need.
          let kite = await new KiteConnect('s8r229rs5vrd6yzn');

          // Add another stock
          kite.add({
            exchange: 'NSE',
            tradingsymbol: stock_code,
            quantity: 1,
            order_type: 'LIMIT',
            // "transaction_type": "SELL",
            // "price": 105
          });

          // Register an (optional) callback.
          kite.finished(function (status, request_token) {});

          let id = '#default-button' + reco_id;

          // Render the in-built button inside a given target
          kite.renderButton(id);

          // OR, link the basket to any existing element you want
          // kite.link("#custom-button");
        });
      }
    },

    handleRecommendationDialog() {
      this.update_recommendation_dialog_visible = false;
      this.exit_reco_popup_visible = false;
      this.reco_loading = false; //hide loader
    },

    // close stock widget dialog
    handleClose() {
      this.stock_widget_visible = false;
    },

    getRecoByStockName(reco) {
      this.page_no = 1;
      this.past_reco_track_list = []; //cleared previous results
      this.stock_list = reco.stock.id;
      this.scrollToTop(); //scroll to top of list
      this.getAllPastRecoList(this.filter_obj);
    },

    //when reco type is changed then resets target period input and potential return
    selectRecoType(current_price, reco_type) {
      this.selected_reco_to_update.reco = reco_type;
      this.selected_reco_to_update.is_unlocked = false; //to disable check antestimate link
      this.selected_reco_to_update.is_recommended = false; //reset is_recommended stock
      this.selected_reco_to_update.validate_target_price = false; //disable validate price error

      //to reset target price & potential return as per reco conditions
      this.resetPotentialReturnAndTargetPrice(reco_type);

      this.selected_reco_to_update.duration = null; // this is for clear the target period when reco type change

      // reset logic tags on update target period
      this.filtered_logic_list = [];
      this.selected_reco_to_update.selected_logic_list = [];

      this.getTagsDataList();
    },

    resetPotentialReturnAndTargetPrice(reco_type) {
      if (reco_type == 'Buy') {
        //reset target price by adding 1 beacuse reco type is Buy
        let target_price = (this.selected_reco_to_update.current_price + 2).toFixed();
        let current_price = this.selected_reco_to_update.current_price;

        let target_price_potential = this.getPotentailReturn(target_price, current_price, reco_type);
        let reco_price_potential = this.getPotentailReturn(current_price, current_price, reco_type);

        this.selected_reco_to_update.reco_price = Number(current_price);
        this.selected_reco_to_update.target_price = target_price;
        this.selected_reco_to_update.stop_loss = '';

        //calculated potential return initially when price is initiallised
        this.selected_reco_to_update.reco_price_potential = reco_price_potential;
        this.selected_reco_to_update.target_price_potential = target_price_potential;
        this.selected_reco_to_update.stop_loss_potential = '';
      } else if (reco_type == 'Sell') {
        //reset target price by decreasing 1 beacuse reco type is Sell
        let target_price = Number((this.selected_reco_to_update.current_price - 2).toFixed());
        let current_price = this.selected_reco_to_update.current_price;

        let reco_price_potential = this.getPotentailReturn(current_price, current_price, reco_type);
        let target_price_potential = this.getPotentailReturn(target_price, current_price, reco_type);

        this.selected_reco_to_update.reco_price = Number(current_price);
        this.selected_reco_to_update.target_price = target_price;
        this.selected_reco_to_update.stop_loss = '';

        //calculated potential return initially when price is initiallised
        this.selected_reco_to_update.reco_price_potential = reco_price_potential;
        this.selected_reco_to_update.target_price_potential = target_price_potential;
        this.selected_reco_to_update.stop_loss_potential = '';
      } else {
        //reset target price
        let target_price = Number(this.selected_reco_to_update.current_price.toFixed()) + 1;
        let current_price = this.selected_reco_to_update.current_price;

        let target_price_potential = this.getPotentailReturn(target_price, current_price, reco_type);
        let reco_price_potential = this.getPotentailReturn(current_price, current_price, reco_type);

        this.selected_reco_to_update.reco_price = Number(current_price);
        this.selected_reco_to_update.target_price = target_price;
        this.selected_reco_to_update.stop_loss = '';

        //calculated potential return initially when price is initiallised
        this.selected_reco_to_update.reco_price_potential = reco_price_potential;
        this.selected_reco_to_update.target_price_potential = target_price_potential;
        this.selected_reco_to_update.stop_loss_potential = '';
      }

      // disabled price error label
      this.selected_reco_to_update.validate_target_price = false;
      this.selected_reco_to_update.validate_reco_price = false;
      this.selected_reco_to_update.validate_stop_loss = false;
    },

    // validate reco price input
    validateRecoPrice(price, current_price, reco_type) {
      // let reg = /^[-+]?\d+(\.\d+)?$/; //regex for non negative values

      let reco_price = Number(price);
      let target_price = Number(current_price).toFixed();
      let stock_price = Number(this.selected_reco_to_update.current_price);

      this.selected_reco_to_update.is_recommended = false;
      this.selected_reco_to_update.is_unlocked = false; //to disable check antestimate link

      if (reco_type == 'Buy') {
        // rounded value using toFixed() because current price is a fractional value
        if (reco_price > 1 && reco_price > 0) {
          this.selected_reco_to_update.validate_reco_price = false;
          this.selected_reco_to_update.reco_price_potential = this.getPotentailReturn(reco_price, stock_price, reco_type);

          // validate target price input
          if (this.selected_reco_to_update.target_price <= reco_price) {
            this.selected_reco_to_update.validate_target_price = true;

            this.selected_reco_to_update.target_price_error_text = 'Target price must be greater than reco price';
          } else {
            this.selected_reco_to_update.validate_target_price = false;
          }

          // validate stop loss input
          if (this.selected_reco_to_update.stop_loss) {
            if (Number(this.selected_reco_to_update.stop_loss) < reco_price) {
              this.selected_reco_to_update.validate_stop_loss = false;
            } else {
              this.selected_reco_to_update.validate_stop_loss = true;

              this.selected_reco_to_update.stop_loss_error_text = 'Stop loss must be lower than reco price';
            }
          }
        } else {
          this.selected_reco_to_update.reco_price_potential = this.getPotentailReturn(0, 0, reco_type);
          this.selected_reco_to_update.validate_reco_price = true;
          this.selected_reco_to_update.reco_price_error_text = 'Reco price must be positive integer';
        }
      } else if (reco_type == 'Sell') {
        if (reco_price > 1 && reco_price > 0) {
          this.selected_reco_to_update.validate_reco_price = false;
          this.selected_reco_to_update.reco_price_potential = this.getPotentailReturn(reco_price, current_price, reco_type);

          // validate target price input
          if (this.selected_reco_to_update.target_price < reco_price) {
            this.selected_reco_to_update.validate_target_price = false;
          } else {
            this.selected_reco_to_update.validate_target_price = true;

            this.selected_reco_to_update.target_price_error_text = 'Target price must be lower than reco price';
          }

          // validate stop loss input
          if (this.selected_reco_to_update.stop_loss) {
            if (Number(this.selected_reco_to_update.stop_loss) > reco_price) {
              this.selected_reco_to_update.validate_stop_loss = false;
            } else {
              this.selected_reco_to_update.validate_stop_loss = true;

              this.selected_reco_to_update.stop_loss_error_text = 'Stop loss must be greater than reco price';
            }
          }
        } else {
          this.selected_reco_to_update.reco_price_potential = this.getPotentailReturn(0, 0, reco_type);
          this.selected_reco_to_update.validate_reco_price = true;
          this.selected_reco_to_update.reco_price_error_text = 'Reco price must be positive integer';
        }
      } else if (reco_type == 'Hold') {
        if (reco_price > 0) {
          this.selected_reco_to_update.reco_price_potential = this.getPotentailReturn(reco_price, stock_price, reco_type);
          this.selected_reco_to_update.validate_reco_price = false;

          // validate target price input
          if (this.selected_reco_to_update.target_price > reco_price) {
            let price = this.checkPercentageForHoldRecoType(this.selected_reco_to_update.target_price, reco_price, 'INCREASE');

            if (this.selected_reco_to_update.target_price > price) {
              this.selected_reco_to_update.validate_target_price = true;
              this.selected_reco_to_update.target_price_error_text = `Target price must be less than ${price.toFixed()}`;
            } else {
              this.selected_reco_to_update.validate_target_price = false;
            }
          } else {
            let price = this.checkPercentageForHoldRecoType(this.selected_reco_to_update.target_price, reco_price, 'DECREASE');

            if (this.selected_reco_to_update.target_price < price) {
              this.selected_reco_to_update.validate_target_price = true;
              this.selected_reco_to_update.target_price_error_text = `Target price must be greater than ${price.toFixed()}`;
            } else {
              this.selected_reco_to_update.validate_target_price = false;
            }
          }
        } else {
          this.selected_reco_to_update.reco_price_potential = this.getPotentailReturn(0, 0, reco_type);
          this.selected_reco_to_update.validate_reco_price = true;
          this.selected_reco_to_update.reco_price_error_text = 'Reco price must be positive integer';
        }
      }
    },

    // validate target price input
    validateTargetPrice(target_price, current_price, reco_type) {
      target_price = Number(target_price);
      // let reg = /^[-+]?\d+(\.\d+)?$/; //regex for non negative values

      let reco_price = Number(this.selected_reco_to_update.reco_price);

      this.selected_reco_to_update.is_recommended = false;
      this.selected_reco_to_update.is_unlocked = false; //to disable check antestimate link

      if (reco_type == 'Buy') {
        // rounded value using toFixed() because current price is a fractional value
        if (target_price > 0 && Number(target_price) > reco_price) {
          this.selected_reco_to_update.validate_target_price = false;
          this.selected_reco_to_update.target_price_potential = this.getPotentailReturn(target_price, current_price, reco_type);

          // // validate reco price input
          // if(this.selected_reco_to_update.reco_price < target_price && this.selected_reco_to_update.reco_price >= this.selected_reco_to_update.current_price){
          //   this.selected_reco_to_update.validate_reco_price = false;
          // }else{
          //   this.selected_reco_to_update.validate_reco_price = true;
          //   this.selected_reco_to_update.reco_price_error_text = "Reco price must be positive integer & greater than current price & lower than target price";
          // }
        } else {
          this.selected_reco_to_update.target_price_potential = this.getPotentailReturn(0, 0, reco_type);
          this.selected_reco_to_update.validate_target_price = true;
          this.selected_reco_to_update.target_price_error_text = 'Target price must be positive integer and greater than reco price';
        }
      } else if (reco_type == 'Sell') {
        if (target_price > 1 && Number(target_price) < reco_price) {
          this.selected_reco_to_update.validate_target_price = false;
          this.selected_reco_to_update.target_price_potential = this.getPotentailReturn(target_price, current_price, reco_type);

          // // validate reco price input
          // if(this.selected_reco_to_update.reco_price > target_price && this.selected_reco_to_update.reco_price <= this.selected_reco_to_update.current_price){
          //   this.selected_reco_to_update.validate_reco_price = false;
          // }else{
          //   this.selected_reco_to_update.validate_reco_price = true;
          //   this.selected_reco_to_update.reco_price_error_text = "Reco price must be positive integer & lower than current price & greater than target price";
          // }
        } else {
          this.selected_reco_to_update.target_price_potential = this.getPotentailReturn(0, 0, reco_type);
          this.selected_reco_to_update.validate_target_price = true;
          this.selected_reco_to_update.target_price_error_text = 'Target price must be positive integer and lower than reco price';
        }
      } else if (reco_type == 'Hold') {
        if (target_price > 1) {
          if (target_price > reco_price) {
            let price = this.checkPercentageForHoldRecoType(target_price, reco_price, 'INCREASE');

            if (target_price > price) {
              this.selected_reco_to_update.validate_target_price = true;
              this.selected_reco_to_update.target_price_error_text = `Target price must be less than ${price.toFixed()}`;
            } else {
              this.selected_reco_to_update.validate_target_price = false;
            }
          } else {
            let price = this.checkPercentageForHoldRecoType(target_price, reco_price, 'DECREASE');

            if (target_price < price) {
              this.selected_reco_to_update.validate_target_price = true;
              this.selected_reco_to_update.target_price_error_text = `Target price must be greater than ${price.toFixed()}`;
            } else {
              this.selected_reco_to_update.validate_target_price = false;
            }
          }

          this.selected_reco_to_update.target_price_potential = this.getPotentailReturn(target_price, current_price, reco_type);
        } else {
          this.selected_reco_to_update.target_price_potential = this.getPotentailReturn(0, 0, reco_type);
          this.selected_reco_to_update.validate_target_price = true;
          this.selected_reco_to_update.target_price_error_text = 'Target price must be positive integer';
        }
      }
    },

    // validate stop loss input
    validateStopLoss(stop_loss, current_price, reco_type) {
      stop_loss = Number(stop_loss);
      if (stop_loss) {
        //ignored white spaces

        // let reg = /^[-+]?\d+(\.\d+)?$/; //regex for non negative values

        let reco_price = Number(this.selected_reco_to_update.reco_price);

        this.selected_reco_to_update.is_recommended = false;
        this.selected_reco_to_update.is_unlocked = false; //to disable check antestimate link

        if (reco_type == 'Buy') {
          // rounded value using toFixed() because current price is a fractional value

          if (stop_loss > 1 && Number(stop_loss) < reco_price) {
            this.selected_reco_to_update.validate_stop_loss = false;
            this.selected_reco_to_update.stop_loss_potential = this.getPotentailReturn(stop_loss, current_price, reco_type);
          } else {
            this.selected_reco_to_update.stop_loss_potential = this.getPotentailReturn(0, 0, reco_type);
            this.selected_reco_to_update.validate_stop_loss = true;
            this.selected_reco_to_update.stop_loss_error_text = 'Stop loss must be positive integer and lower than reco price';
          }
        } else if (reco_type == 'Sell') {
          if (stop_loss > 1 && Number(stop_loss) > reco_price) {
            this.selected_reco_to_update.validate_stop_loss = false;
            this.selected_reco_to_update.stop_loss_potential = this.getPotentailReturn(stop_loss, current_price, reco_type);
          } else {
            this.selected_reco_to_update.stop_loss_potential = this.getPotentailReturn(0, 0, reco_type);
            this.selected_reco_to_update.validate_stop_loss = true;
            this.selected_reco_to_update.stop_loss_error_text = 'Stop loss must be positive integer and greather than reco price';
          }
        } else if (reco_type == 'Hold') {
          if (stop_loss > 1) {
            this.selected_reco_to_update.validate_stop_loss = false;
            this.selected_reco_to_update.stop_loss_potential = this.getPotentailReturn(stop_loss, current_price, reco_type);
          } else {
            this.selected_reco_to_update.stop_loss_potential = this.getPotentailReturn(0, 0, reco_type);
            this.selected_reco_to_update.validate_stop_loss = true;
            this.selected_reco_to_update.stop_loss_error_text = 'Stop loss must be positive integer';
          }
        }
      } else {
        this.selected_reco_to_update.validate_stop_loss = false;

        this.selected_reco_to_update.stop_loss_potential = this.getPotentailReturn(0, 0, reco_type);
      }
    },

    checkPercentageForHoldRecoType(target_price, current_price, type) {
      let price = '';

      if (type == 'INCREASE') {
        price = current_price + (current_price * 4) / 100;
      } else {
        price = current_price - (current_price * 4) / 100;
      }
      return price;
    },

    calculateStopLoss(reco_price, target_price) {
      this.selected_reco_to_update.added_first = 'target price';
      this.validateStopLoss(this.selected_reco_to_update.stop_loss, this.selected_reco_to_update.current_price, this.selected_reco_to_update.reco);
    },

    calculateTargetPrice(reco_price, stop_loss) {
      this.selected_reco_to_update.added_first = 'stop loss';
      this.validateTargetPrice(this.selected_reco_to_update.target_price, this.selected_reco_to_update.current_price, this.selected_reco_to_update.reco);
    },

    // api to update recommendation
    updateReco(item) {
      let recos_to_be_upload = [];
      let is_category_stamp_required = false;
      let obj = {};

      obj.reco_update_type = 'EDIT';

      obj.duration = this.selected_reco_to_update.duration;

      obj.reco_price_type = this.selected_reco_to_update.reco_price_type;
      obj.logic_tags = this.selected_reco_to_update.selected_logic_list;
      obj.validate_target_price = this.selected_reco_to_update.validate_target_price;
      obj.validate_reco_price = this.selected_reco_to_update.validate_reco_price;
      obj.validate_stop_loss = this.selected_reco_to_update.validate_stop_loss;
      obj.edit_description = this.selected_reco_to_update.edit_description;
      obj.exit_description = this.selected_reco_to_update.exit_description;

      if (item.stop_loss) {
        obj.stop_loss = Number(item.stop_loss);
      }

      // Risk-Reward Ratio Check
      const reco_price = Number(item.reco_price);
      const target_price = Number(item.target_price);
      const stop_loss = Number(item.stop_loss);

      const gain = Math.abs(target_price - reco_price);
      const loss = Math.abs(stop_loss - reco_price);

      if (gain && loss && gain / loss < 1) {
        new CripNotice({
          title: 'Alert ',
          description: 'Risk-Reward Ratio for this recommendation is below 1:1.',
          type: 'warning',
          duration: 3,
        });
        return;
      }
      // if user is not sebi registered but he has selected less than 3 tags give error
      if (!item.stamps_list.length) {
        is_category_stamp_required = true;
      } else {
        obj.category_stamp = item.stamps_list;
      }

      // if reco status is live then allow to updated target price and stop loss
      // if reco status is YET TO LIVE then allow to update everything

      if (item.reco_status == 'LIVE' || item.reco_status == 'UPDATED') {
        obj.target_price = Number(item.target_price);
        obj.reco = item.reco;
      } else {
        obj.reco = item.reco;
        obj.target_price = Number(item.target_price);
        obj.reco_open_price = Number(item.reco_price);

        if (item.short_term_duration) {
          let target_res = this.short_term_target_period_list.filter((e) => {
            return e.value == item.short_term_duration;
          });

          if (target_res.length) {
            obj.result_date = item.short_term_duration;
            obj.number = target_res[0].number;
            obj.year = target_res[0].year;
            obj.duration = target_res[0].duration;
          }
        } else {
          let target_res = this.long_term_target_period_list.filter((e) => {
            return e.result_date == item.long_term_duration;
          });

          if (target_res.length) {
            obj.result_date = item.long_term_duration;
            obj.number = target_res[0].number;
            obj.year = target_res[0].year;
            obj.duration = target_res[0].duration;
          }
        }
      }

      if (item.selected_duration) {
        obj.result_date = item.selected_duration_list[0].result_date;
        obj.number = item.selected_duration_list[0].number;
        obj.year = item.selected_duration_list[0].year;
        obj.duration = item.selected_duration_list[0].duration;
      }

   //  Check for edit description
  if (!obj.edit_description || !obj.edit_description.trim()) {
    new CripNotice({
      title: 'Error',
      description: 'Edit description is required.',
      type: 'error',
      duration: 3,
    });
    return;
  }

      if (obj.reco && obj.result_date && obj.target_price && !obj.validate_target_price && !obj.validate_reco_price && !obj.validate_stop_loss && obj.logic_tags.length >= 3 && !is_category_stamp_required) {
        if (item.duration == 'Short-Term' || item.duration == 'Intra' || item.duration == 'Mid-Term') {
          if (item.stop_loss) {
            recos_to_be_upload.push(obj);
          } else {
            is_stop_loss_required = true;
          }
        } else {
          recos_to_be_upload.push(obj);
        }
      }

      if (recos_to_be_upload.length) {
        this.selected_reco_to_update.is_btn_loading = true; //enabled btn loading
        this.reco_loading = true; //enabled btn loading

        serverAddr
          .patch(`/recommendation/v1/edit/${this.selected_reco_to_update.reco_id}`, recos_to_be_upload[0])
          .then((response) => {
            if (response.data.status) {
              new CripNotice({
                title: 'Success',
                description: 'Recommendation updated',
                type: 'success',
                duration: 3,
              });

              // get updated reco details and update it
              let updated_reco = response.data.data;

              // created new key toggle_more_info in response for toggle more info section
              this.$set(updated_reco, 'toggle_more_info', false);
              this.$set(updated_reco, 'expert_list', []);
              this.$set(updated_reco, 'closed_reco_list', []);
              this.$set(updated_reco, 'closed_reco_list_loading', false);
              this.$set(updated_reco, 'is_loading', false);
              this.$set(updated_reco, 'compared_experts_list', []);

              if (updated_reco.created_at != null && updated_reco.stock.today != null) {
                //calculate difference between today & created date
                //if reco is closed then sent closed day
                //if target is achieved then send target achieved date
                //if target is not achieved and accuracy is out then send result_date_time

                let start_date = updated_reco.created_at;

                updated_reco.reco_status == 'STOP LOSS TRIGGERED' || updated_reco.reco_status == 'TARGET NOT ACHIEVED';

                let end_date = updated_reco.reco_status == 'TARGET ACHIEVED' ? updated_reco.target_achieved_date_time : updated_reco.reco_status == 'TARGET NOT ACHIEVED' ? updated_reco.target_not_achieved_date_time : updated_reco.reco_status == 'STOP LOSS TRIGGERED' ? updated_reco.stop_loss_triggered_date_time : updated_reco.stock.today;

                updated_reco.difference_in_days = this.getDifferenceBetweenTwoDays(start_date, end_date);

                this.openTradeWidget(updated_reco.stock.symbol, updated_reco.id);
              } else {
                updated_reco.difference_in_days = 0;
              }

              // this.past_reco_track_list.splice(this.selected_reco_index, 1);

              this.past_reco_track_list.splice(this.selected_reco_index, 1, updated_reco);

              // this.getAllPastRecoList(this.filter_obj);

              this.update_recommendation_dialog_visible = false; //closed dialog
            }

            this.selected_reco_to_update.is_btn_loading = false; //disabled btn loading
            this.reco_loading = false; //disabled btn loading
          })
          .catch((error) => {
            console.log(error);
            this.selected_reco_to_update.is_btn_loading = false; //disabled btn loading
            this.reco_loading = false; //disabled btn loading
          });
      } else {
        var errDescription = 'Please fill all fields in correct format';

        new CripNotice({
          title: 'Error',
          description: errDescription,
          type: 'error',
          duration: 3,
        });
        // }
      }
    },

    scrollToTop() {
      var elmnt = document.getElementsByClassName('recoListSection');
      scrollTo(elmnt, 0, 100);
    },

    //get target period list
    getTargetPeriod() {
      return serverAddr
        .get('/recommendation/v1/reco_target_period')
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_stock_list_loading = false;
          }.bind(this)
        );
    },

    loadMoreRecommendations() {
      this.page_no = this.page_no + 1;
      // this.number_of_pages = null;     //to disable load more tab
      this.getAllPastRecoList(this.filter_obj);
    },

    //api to get past recommendation
    getAllPastRecoList(filter_obj) {
      this.is_list_loading = true;

      serverAddr
        .post('/recommendation/v1/read_recommendation', {
          sector: filter_obj.sector,
          stock_id: this.stock_list,
          target_period: filter_obj.target_period ? filter_obj.target_period : '',
          filters: filter_obj.filters ? filter_obj.filters : [],
          page_no: this.page_no,
          recommendation_by: 'user',
          page_per_entries: 5,
        })
        .then((response) => {
          if (response.data.status) {
            this.is_list_loading = false;
            // this.is_scroll_disabled = true;   //enable scroll for more stock
            this.number_of_pages = response.data.pagination.total_pages;

            response.data.data.forEach((element, index) => {
              // created new key toggle_more_info in response for toggle more info section
              this.$set(element, 'toggle_more_info', false);
              this.$set(element, 'expert_list', []);
              this.$set(element, 'closed_reco_list', []);
              this.$set(element, 'closed_reco_list_loading', false);
              this.$set(element, 'is_loading', false);
              this.$set(element, 'compared_experts_list', []);
              this.$set(element, 'selected_brokerage_list', element.brokerage_data.IntraDay[0].data);
              this.$set(element, 'brokerage_list_type', 'IntraDay');
              this.$set(element, 'reco_quantity', 1);
              this.$set(element, 'exp_tax', element.brokerage_data.IntraDay[0].data.total_tax_and_charges);
              this.$set(element, 'brokerage_loader', false);
              this.$set(element, 'selectedRiskTag', element.risk_tag);
              this.$set(element, 'selectedLogicTags', element.logic_tags);
              this.$set(element, 'logic_description', element.report.length ? element.report[0].description : '');

              if (element.created_at != null && element.stock.today != null) {
                //calculate difference between today & created date
                //if reco is closed then sent closed day
                //if target is achieved then send target achieved date
                //if target is not achieved and accuracy is out then send result_date_time

                let start_date = element.created_at;

                element.reco_status == 'STOP LOSS TRIGGERED' || element.reco_status == 'TARGET NOT ACHIEVED';

                let end_date = element.reco_status == 'TARGET ACHIEVED' ? element.target_achieved_date_time : element.reco_status == 'TARGET NOT ACHIEVED' ? element.target_not_achieved_date_time : element.reco_status == 'STOP LOSS TRIGGERED' ? element.stop_loss_triggered_date_time : element.stock.today;

                element.difference_in_days = this.getDifferenceBetweenTwoDays(start_date, end_date);

                this.openTradeWidget(element.stock.symbol, element.id);
              } else {
                element.difference_in_days = 0;
              }

              this.past_reco_track_list.push(response.data.data[index]);
            });

            // this.scrollToTop();     //scroll to top of list
          } else {
            this.is_list_loading = false;
            // this.is_scroll_disabled = false;
            this.past_reco_track_list = [];
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_list_loading = false;
            // this.is_scroll_disabled = false;
          }.bind(this)
        );
    },

    //api to get recommendation by reco id
    getRecommendationByRecoId(reco_id) {
      this.is_list_loading = true;

      serverAddr
        .get(`/recommendation/v1/detail/${reco_id}`)
        .then((response) => {
          if (response.data.status) {
            this.is_list_loading = false;
            // this.number_of_pages = response.data.pagination.total_pages;

            let reco = response.data.data;

            // created new key toggle_more_info in response for toggle more info section
            this.$set(reco, 'toggle_more_info', false);
            this.$set(reco, 'expert_list', []);
            this.$set(reco, 'closed_reco_list', []);
            this.$set(reco, 'closed_reco_list_loading', false);
            this.$set(reco, 'is_loading', false);
            this.$set(reco, 'compared_experts_list', []);
            if (reco.created_at != null && reco.stock.today != null) {
              //calculate difference between today & created date
              //if reco is closed then sent closed day
              //if target is achieved then send target achieved date
              //if target is not achieved and accuracy is out then send result_date_time

              let start_date = reco.created_at;

              reco.reco_status == 'STOP LOSS TRIGGERED' || reco.reco_status == 'TARGET NOT ACHIEVED';

              let end_date = reco.reco_status == 'TARGET ACHIEVED' ? reco.target_achieved_date_time : reco.reco_status == 'TARGET NOT ACHIEVED' ? reco.target_not_achieved_date_time : reco.reco_status == 'STOP LOSS TRIGGERED' ? reco.stop_loss_triggered_date_time : reco.stock.today;

              reco.difference_in_days = this.getDifferenceBetweenTwoDays(start_date, end_date);

              this.openTradeWidget(reco.stock.symbol, reco.id);
            } else {
              reco.difference_in_days = 0;
            }

            this.past_reco_track_list.push(reco);

            // this.scrollToTop();     //scroll to top of list
          } else {
            this.is_list_loading = false;
            this.past_reco_track_list = [];
          }
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_list_loading = false;
          }.bind(this)
        );
    },

    loadMoreStocks() {
      window.onscroll = () => {
        //checked is window scrolled to bottom
        if (window.innerHeight + window.scrollY >= document.body.scrollHeight && this.is_scroll_disabled && this.number_of_pages > this.page_no) {
          // you're at the bottom of the page
          this.page_no = this.page_no + 1;
          this.getAllPastRecoList(this.filter_obj);
          this.is_scroll_disabled = false; //disabled scroll to avoid many time function call
        }
      };
    },
  },

  beforeDestroy() {
    EventBus.$off();
    // window.removeEventListener('scroll', this.loadMoreStocks());
    // this.is_scroll_disabled = false;
  },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.PastRecommendations {
  // min-height: 100vh;
  background-color: $page-background-color;
  padding: 60px 0 60px 0;
  .search-container {
    box-sizing: border-box;
    position: fixed;
    width: calc(100% - 282px);
    margin-left: 282px;
    padding: 0px 10px 0px 10px;
    background-color: #ffff;
    z-index: 1;
    box-shadow: 0px -2px 14px 0px #d6d6d6;
  }

  .search-stock-section {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    background-color: #ffff;
    padding: 15px 20px 15px 0px;
    width: 100%;
  }

  .export-btn {
    font-size: 12px;
    padding: 4px 10px;
    margin-left: 8px;
  }

  .filter-icon {
    border: 1px solid #ecf4ff;
    padding: 5px;
    display: flex;
    align-items: center;
    background: #ecf4ff;
    justify-content: center;
    border-radius: 4px;
    margin-left: 5px;
  }

  .recoListSection {
    box-sizing: border-box;
    width: calc(100% - 285px);
    margin-left: 285px;
    padding: 0 10px;
    min-height: calc(100vh - 120px);
  }

  .footer-section {
    width: calc(100% - 285px);
    margin-left: 285px;
  }

}

//media queries
@media screen and (max-width: 1283px) {
  .PastRecommendations {
    padding: 50px 0 80px 0;

    .recoListSection {
      width: 100%;
      margin-left: 0;
    }

    .footer-section {
      width: 100%;
      margin-left: 0;
    }

    .search-container {
      width: 100%;
      margin-left: 0;
      padding: 0;
    }

    .search-stock-section {
      // display: block;
      padding: 20px 30px 10px 10px;
    }

    .stock-data-section {
      padding: 60px 0px 0;
    }

    .action-btn-component {
      display: flex;
      justify-content: center;
      margin: 10px 0;
    }
  }

  .desktopFilterSection {
    display: none;
  }
}

@media screen and (max-width: 600px) {
  .PastRecommendations .recoListSection {
    padding: 0;
  }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.PastRecommendations {
  .custom-seach-input {
    width: 240px;
  }
  .update-reco-card {
    box-shadow: none;
  }

  .rupees-symbol {
    position: absolute;
    top: 7px;
    left: 15px;
    z-index: 1;
    font-size: 0.9rem;
    color: black;
    font-weight: bold;
  }

  .percentSymbol {
    position: absolute;
    top: 5px;
    right: 80px;
    z-index: 1;
    color: #606266;
  }

  .unlocked-antestimate-notifybar {
    cursor: pointer;
    color: black;
    font-weight: 800;
    width: 100%;
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    opacity: 1;
    display: flex;
    transition: opacity 0.2s;
    font-size: 1.2rem;
  }

  .selection-tag {
    font-size: 0.7rem;
    height: 25px;
    line-height: 24px;
  }

  .stock-details-section {
    display: flex;
    align-items: center;
  }

  .stock-title {
    max-width: 300px;
  }

  .current-price {
    font-size: 1.2rem;
    font-weight: 600;
    color: #000;
  }

  .border-bottom-gray {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
  }

  .cross-icon {
    color: #ddd;
    font-size: 20px;
    cursor: pointer;
  }

  .cross-icon:hover {
    font-size: 20px;
    color: #000;
  }

  .el-select-dropdown__item {
    color: #000 !important;
    font-weight: 300 !important;
  }

  .target-price-input {
    width: 100%;
  }

  .sector-dropdown .el-input__inner {
    border-radius: 12px;
    height: 20px;
    border-radius: 10px;
    font-size: 0.6rem;
    text-transform: uppercase;
    font-weight: 500;
    color: #000;
  }

  .target-price-input-section .el-input__inner::placeholder {
    font-size: 0.8rem;
    font-weight: 500;
  }

  .el-select .el-input .el-select__caret.is-reverse {
    position: absolute;
    top: -4px;
    right: 0;
  }

  .sector-dropdown .el-select__caret {
    position: absolute;
    top: 3px;
    right: 0;
  }

  .sector-dropdown .el-select__caret {
    font-size: 13px;
  }

  .target-price-input .el-input-number__increase,
  .target-price-input .el-input-number__decrease {
    line-height: 0;
    border-radius: 50px;
    width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
    border: none;
    background-color: $secondary-theme-color;
    border-color: $secondary-theme-color;
    color: #fff;
    display: none;
  }

  .target-price-input .el-input-number__decrease {
    right: 35px;
    top: 5px;
  }

  .target-price-input .el-input-number__increase {
    right: 5px;
    top: 5px;
  }

  .target-price-input-section .el-input__inner {
    text-align: left;
    // height: 35px;
    padding-left: 30px;
    color: black;
    font-weight: 600;
    font-size: 0.9rem;
  }

  .potential-return-value {
    font-size: 0.7rem;
    font-weight: 600;
    position: absolute;
    top: 8px;
    right: 8px;
    // right: 30%;
    z-index: 1;
    color: #979797;
  }

  .inactive-period-type-tag {
    text-align: center;
    border-radius: 12px;
    padding: 0 10px;
    margin: 0 0.3rem 0 0;
    background-color: #fff;
    border-color: #d9d9d9;
    font-weight: 600;
    color: #878787;
    min-width: 50px;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 10px;
  }

  .disabled-period-type-tag {
    margin-right: 0.3rem;
    border-radius: 12px;
    padding: 0 10px;
    min-width: 50px;
    font-weight: 600;
    text-align: center;
    border-color: #ddd;
    background-color: #ddd;
    color: #fff;
    text-transform: uppercase;
    font-size: 10px;
    cursor: not-allowed;
  }

  .active-period-type {
    margin-right: 0.3rem;
    border-radius: 12px;
    padding: 0 10px;
    min-width: 50px;
    font-weight: 600;
    text-align: center;
    border-color: $secondary-theme-color;
    background-color: $secondary-theme-color;
    color: #fff;
    text-transform: uppercase;
    font-size: 10px;
  }

  .active-period-type:focus,
  .inactive-period-type-tag:focus {
    outline: none;
  }

  .el-button.is-disabled.is-plain {
    border-radius: 61px;
  }

  .el-button.is-disabled.is-plain {
    background-color: #eee;
  }

  .info-Logo {
    height: 9px;
    padding: 0px 2px 0px 3px;
  }

  .NoDataFound {
    padding: 60px 0 0 0;
  }

  .quarter-tag {
    // width: 170px;
    input {
      //border-radius: 25px;
      // height: 25px;
    }

    input::placeholder {
      // color: $primary-theme-color;
      // font-size: 10px;
      font-weight: 500;
    }
  }

  .active-quarter {
    input {
      background-color: $secondary-theme-color;
      border-color: $secondary-theme-color;
      color: #fff;
    }

    .el-select__caret {
      color: #fff;
    }
  }

  .upload-btn {
    background: #d5d3e0;
    color: #000;
    padding: 5px 15px;
    border-radius: 50px;
    font-size: 0.7rem;
    font-weight: 500;
    width: fit-content;
    cursor: pointer;
  }
}

.reco-update-dialog {
  width: 60%;
  border-radius: 8px;
  .el-dialog__body {
    padding: 0px 20px 10px;
  }

  .stamp-dropdown {
    .el-tag.el-tag--info {
      background-color: #e72726;
      border-color: #e72726;
      color: #fff;
      font-weight: 600;
      border-radius: 5px;
    }
    .el-tag.el-tag--info .el-tag__close {
      color: #000;
      background-color: #fff;
    }
  }
}

@media screen and (max-width: 650px) {
  .reco-update-dialog {
    width: 90%;
  }

  .PastRecommendations {
    .custom-seach-input {
      width: 100%;
    }
  }
}
</style>
